import React, { useState, useEffect } from "react";
import { FaStar, FaSun, FaMoon, FaRegLightbulb, FaChild } from "react-icons/fa";
import "../styles/Services.css";
import Testimonials from "../components/Testimonials";
import natalImg from "../assets/natalna_karta.jpeg";
import sinastrijaImg from "../assets/sinastrija.jpeg";
import solarImg from "../assets/letni horoskop.jpeg";
import karmicNatalImg from "../assets/karmicna_natalna_karta.jpeg";
import karmicSinastrijaImg from "../assets/karmicna_sinastrija.jpeg";
import childImg from "../assets/natalna_karta.jpeg";

const ServiceModal = ({ service, onClose }) => {
  if (!service) return null;

  const Icon = service.icon;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        {service.image && (
          <div className="modal-image-wrap">
            <img
              src={service.image}
              alt={service.title}
              className="modal-image"
            />
          </div>
        )}
        <div className="modal-header">
          <div className="modal-icon">
            <Icon size={40} />
          </div>
          <h2 className="modal-title">{service.title}</h2>
        </div>
        <div className="modal-body">
          {service.description.split("\\n\\n").map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
        </div>
        <div className="modal-details">
          {service.duration && (
            <p className="modal-duration">Trajanje: {service.duration}</p>
          )}
          {service.price && (
            <p className="modal-price">
              <strong>Cena: {service.price}</strong>
            </p>
          )}
        </div>
        {service.link && (
          <a
            href={service.link}
            target="_blank"
            rel="noopener noreferrer"
            className="button primary modal-button"
          >
            Rezerviraj termin
          </a>
        )}
      </div>
    </div>
  );
};

const ServiceCard = ({
  icon: Icon,
  title,
  description,
  shortDescription,
  link,
  price,
  duration,
  image,
  onShowDetails,
}) => {
  return (
    <div className="service-card card fade-in">
      {image && (
        <div className="service-image-wrap">
          <img src={image} alt={title} className="service-image" />
        </div>
      )}
      <div className="service-icon-and-title">
        <div className="service-icon">
          <Icon size={34} />
        </div>
        <h3 className="service-title">{title}</h3>
      </div>
      <div className="service-description">
        <p>{shortDescription}</p>
      </div>
      <button className="btn-expand" onClick={onShowDetails}>
        Več...
      </button>
      <div className="service-details">
        {duration && <p className="service-duration">Trajanje: {duration}</p>}
        {price && (
          <p className="service-price">
            <strong>Cena: {price}</strong>
          </p>
        )}
      </div>
      {link && (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className="button primary"
        >
          Rezerviraj termin
        </a>
      )}
    </div>
  );
};

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);

  useEffect(() => {
    document.title = "Storitve — Astrologija v Vortexu";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute(
        "content",
        "Profesionalne astrološke storitve: natalna karta, solarni horoskop, sinastrija za pare, karmična analiza. Odkrijte svoj potencial in razumejte življenjske izzive."
      );
    }
  }, []);

  const services = [
    {
      icon: FaStar,
      title: "Natalna Karta",
      image: natalImg,
      shortDescription:
        "Natalna karta je zamrznjena slika neba v trenutku vašega rojstva. Ponuja globok vpogled v vaše talente, izzive in življenjsko poslanstvo ter vam pomaga razumeti osebnostne vzorce in življenjske priložnosti.",
      description:
        'Natalna karta je zamrznjena slika neba v trenutku, ko se natus rodi in je naš glavni pokazatelj scenarija za film z imenom "življenje". Poleg osnovnih rojstnih podatkov (dan, mesec, letnica, kraj rojstva) je ura rojstva izredno pomembna, saj na ta način astrologi izračunamo podznak (Ascendent) natusa.\n\nAstrologi vam s pomočjo natalne karte povemo vse vaše prednosti in pomanjkljivosti. Skozi natalno karto pogledamo tudi karierne poti, finance, prve ljubezni, zakonskega partnerja, družino in nenazadnje vaše življenjsko poslanstvo.\n\nPravi astrolog vam vedno pomaga kako se spopasti z izzivi, ki jih prinaša življenje.\n\nS pomočjo tranzitov in progresij predvidevamo na katerih področjih se bodo dogajale spremembe in kako jih najbolj optimalno izkoristiti. Vse to je zajeto v interpretacijo natalne karte.\n\nInterpretacija natalne karte poteka 1 uro.',
      price: "99 EUR",
      duration: "60 minut",
      link: "https://tidycal.com/astrologija-vortex/natalna-karta",
    },
    {
      icon: FaSun,
      title: "Solarni Horoskop",
      image: solarImg,
      shortDescription:
        "Solarni oziroma letni horoskop opiše energije, ki vas spremljajo skozi leto od rojstnega dne do rojstnega dne. Priporočljivo je, da ga naročite ob vašem rojstnem dnevu.",
      description:
        "Solarni oz. letni horoskop predstavlja trend dogodkov, ki bodo natus spremljali skozi eno leto. Za izdelavo solarnega horoskopa se je smiselno odločiti okoli natusovega rojstnega dne.\n\nNovo solarno leto se začne, ko se tranzitno Sonce poklopi z isto točko kot natalno Sonce. Včasih se zgodi, da se novo solarno leto začne tudi nekaj dni prej ali kasneje kot je naš rojstni dan.\n\nPri solarnem horoskopu astrologe vedno zanima v katerem kraju (državi) ste bili za svoj rojstni dan, saj se na podlagi tega računajo geografske koordinate za tisti kraj. Na podlagi tega lahko vplivate na dogodke, ki se bodo dogajali v tem solarnem letu.\n\nInterpretacija solarnega horoskopa traja 1 uro.",
      price: "99 EUR",
      duration: "60 minut",
      link: "https://tidycal.com/astrologija-vortex/solarni-horoskop",
    },
    {
      icon: FaMoon,
      title: "Sinastrija",
      image: sinastrijaImg,
      shortDescription:
        "Sinastrija analizira kompatibilnost med dvema osebama, bodisi ljubezensko bodisi poslovno. Razkriva dinamiko odnosa, morebitne izzive in potenciale za rast.",
      description:
        "Sinastrija je ena od vej astrologije, ki govori o odnosih. Astrologi skozi sinastrijo ugotavljamo ali sta dve osebi kompatibilni ali ne. S pomočjo te astrološke metode vidimo ali se boste z nekom razumeli, kje so vidni izzivi, morebitni konflikti, seksualna privlačnost, itd. Poleg tega je iz sinastrije prav tako razvidno ali ima lahko ta odnos potencial na dolgi rok ali ne.\n\nZa trden in potencialen odnos so v sinastriji zaslužni ravno izzivalni aspekti (konjunkcija, kvadrat, opozicija).\n\nNajvečkrat se za sinastrijo odločajo ljubezenski in poslovni partnerji, saj s pomočjo te metode lažje razumejo en drugega in se hitreje prilagodijo ljubezenskemu ali poslovnemu partnerju.\n\nJaz zelo rada prej pogledam natalno karto obeh partnerjev in nato še njun skupni horoskop, saj na tak način dobim najboljši vpogled v morebitni potencialni odnos.\n\nZa izdelavo sinastrije potrebujem vse rojstne podatke partnerjev (dan, mesec, letnica, kraj in ura rojstva).\n\nInterpretacija sinastrije traja 1 uro.",
      price: "99 EUR",
      duration: "60 minut",
      link: "https://tidycal.com/astrologija-vortex/sinastrija",
    },
    {
      icon: FaRegLightbulb,
      title: "Karmična Natalna Karta",
      image: karmicNatalImg,
      shortDescription:
        "Poglobljena analiza preteklih življenj. Razkriva karmične lekcije, darove in izzive, ki jih nosite v podzavesti. Razumevanje teh tem vam pomaga razrešiti stare vzorce.",
      description:
        'To je analiza, ki raziskuje možne povezave iz preteklih življenj.\n\nV tradicionalni astrologiji polje karme (12. polje) predstavlja naša dejanja iz prejšnjih življenj in podzavestne procese. Astrologi smo mnenja, da karmične spomine nosimo ravno v naši podzavesti.\n\nPrvi, ki je zaslužen za vsa dogajanja iz prejšnjega življenja je veliki učitelj Saturn, oče karme in usode. Tisto polje v katerem "kraljuje" Saturn, nam predstavlja področje na katerem bo največ preprek in učenja lekcij.\n\nDrugi planet, benefik Jupiter (naši karmični darovi). Postavitev Jupitra v naši natalni karti nam lahko veliko pove o naših karmičnih darovih.\n\nNe smemo pozabiti kako pomembno vlogo imata pri interpretaciji karmične natalne karte tudi Lunin severni in južni vozel. To sta zmajeva glava in zmajev rep, preteklost in sedanjost. Od južnega vozla se v tem življenju poslavljamo in se nagibamo k s severnem vozlu.\n\nRetrogradni planeti v natalni karti imajo prav tako velik pomen pri interpretaciji karmične natalne karte. V tistem polju kjer se nahajajo retrogradni planeti, na tistem področju bo potrebno oddelati največ lekcij.\n\nKot vse astrološke karte, tudi karmične natalne karte izrišem s pomočjo Keplerjevega programa, saj je to en najbolj preciznih programov za izdelovanje vseh vrst astroloških kart.\n\nInterpretacija karmične natalne karte traja eno uro.',
      price: "99 EUR",
      duration: "60 minut",
      link: "https://tidycal.com/astrologija-vortex/karmicna-natalna-karta",
    },
    {
      icon: FaRegLightbulb,
      title: "Karmična Sinastrija",
      image: karmicSinastrijaImg,
      shortDescription:
        "Analiza karmične dinamike v odnosih razkrije vez iz prejšnjih življenj. Spoznajte, ali je vaš odnos začasen karmični ali ima potencial za trajno skupno rast.",
      description:
        'Karmična astrologija je izredno kompleksna, a zelo zanimiva veja astrologije.\n\nAstrolog mora poznati razliko med karmičnimi in karmično-usodnimi zvezami.\n\nKarmične zveze so partnerski odnosi (ljubimci, zakonski partnerji) iz predhodnih inkarnacij. Včasih se ta povezava med dvema osebama vleče samo eno, včasih pa tudi več življenj nazaj. Skozi poglobljeno karmično analizo lahko astrologi vidimo kako "globoka" je karmična vez med partnerjema. To so ponavadi zelo močne povezave med dvema osebama, prepletene z veliko izzivi in preprekami (nedefinirani ljubezenski odnosi, paralelne zveze,...). Ne smemo pozabiti, da so ravno karmične ljubezni tiste najmočnejše, polne ognja in strasti. Te zveze se ponavadi končajo, ko partnerja oddelata lekcijo, ki sta jo prinesla iz prejšnjega življenja.\n\nPri karmično-usodnih zvezah je pot prav tako postlana z izzivi in preprekami, ampak na koncu je zmaga na njihovi strani. Taki pari po oddelanih lekcijah postanejo močnejši in njihov odnos se okrepi. Ti pari so potem nerazdružljivi.\n\nS pomočjo te analize ugotovimo ali je vaša zveza s partnerjem samo karmična ali pa vama je vseeno na koncu zapisan "happy end".\n\nInterpretacija karmične sinastrije traja 1 uro.',
      price: "99 EUR",
      duration: "60 minut",
      link: "https://tidycal.com/astrologija-vortex/karmicna-sinastrija",
    },
    {
      icon: FaChild,
      title: "Natalna Karta Mojega Otroka",
      image: childImg,
      shortDescription:
        "Izdelava natalne karte za vašega otroka vam pomaga razumeti njegove talente, temperament in izobraževalne potenciale. Odkrijte, kako ga lahko najboljše podprete na njegovi poti.",
      description:
        'Ta analiza vključuje izris in poglobljeno analizo natalne karte vašega otroka. Skozi interpretacijo te natalne karte boste bolje razumeli svojega otroka in mu na boljši in lažji način pomagali na njegovi življenjski poti.\n\nSeveda se bomo skozi interpretacijo dotaknili tudi polja zdravja, izobraževanja oz. šolanja (osnovna in srednja šola, diplomski in podiplomski študij) in njegovega življenjskega poslanstva.\n\nSkupaj bomo raziskali kaj so njegove prednosti in morebitni izzivi, ki ga čakajo na življenjski poti ter kako bo najlažje izkoristil svoj potencial.\n\nS pomočjo te analize bo vaš otrok lažje izbral tisto "pravo" pot v življenju.\n\nInterpretacija natalne karte mojega otroka traje 1 uro.',
      price: "99 EUR",
      duration: "60 minut",
      link: "https://tidycal.com/astrologija-vortex/natalna-karta-mojega-otroka",
    },
  ];

  const durationPrices = [
    {
      duration: "30 minut",
      amount: 75,
      note: "Krajši termin",
      featured: false,
    },
    {
      duration: "60 minut",
      amount: 99,
      note: "Najpogosteje izbrano",
      featured: true,
    },
    {
      duration: "90 minut",
      amount: 130,
      note: "Daljši termin",
      featured: false,
    },
    {
      duration: "120 minut",
      amount: 160,
      note: "Poglobljen termin",
      featured: false,
    },
  ];

  return (
    <div className="services-page">
      <h2 className="page-title">Naše storitve</h2>
      <p className="intro-text">
        Astrologija ponuja številne metode za razumevanje vaše osebnosti,
        odnosov in življenjskih ciklov. Spodaj si lahko ogledate storitve, ki so
        skrbno prilagojene vašim potrebam. Vse navedene cene vključujejo DDV.
      </p>
      <div className="services-grid">
        {services.map((service) => (
          <ServiceCard
            key={service.title}
            {...service}
            onShowDetails={() => setSelectedService(service)}
          />
        ))}
      </div>

      <section className="pricing-section" aria-labelledby="pricing-heading">
        <div className="pricing-header">
          <p className="pricing-eyebrow">Redni cenik</p>
          <h3 id="pricing-heading" className="pricing-title">
            Trajanje termina
          </h3>
          <p className="pricing-intro">
            Cene veljajo za vse storitve zgoraj (natalna karta, solarni
            horoskop, sinastrija, karmične analize in natalna karta otroka).
            Termin lahko prilagodimo na 30, 60, 90 ali 120 minut. Vse cene
            vključujejo DDV.
          </p>
        </div>

        <div className="pricing-tiers" role="list">
          {durationPrices.map((tier) => (
            <div
              key={tier.duration}
              className={`pricing-tier${tier.featured ? " is-featured" : ""}`}
              role="listitem"
            >
              {tier.featured && (
                <span className="pricing-tier-badge">Priporočeno</span>
              )}
              <div className="pricing-tier-body">
                <p className="pricing-tier-duration">{tier.duration}</p>
                <p className="pricing-tier-price">
                  <span className="pricing-tier-amount">{tier.amount}</span>
                  <span className="pricing-tier-currency">€</span>
                </p>
                <p className="pricing-tier-note">{tier.note}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="pricing-table-wrap">
          <table className="pricing-table pricing-table--duration">
            <caption className="visually-hidden">
              Redni cenik po trajanju za vse astrološke storitve
            </caption>
            <thead>
              <tr>
                <th scope="col">Trajanje</th>
                <th scope="col">Cena</th>
              </tr>
            </thead>
            <tbody>
              {durationPrices.map((tier) => (
                <tr
                  key={`row-${tier.duration}`}
                  className={tier.featured ? "is-featured-row" : undefined}
                >
                  <td data-label="Trajanje">{tier.duration}</td>
                  <td data-label="Cena">
                    <strong>{tier.amount} €</strong>
                    {tier.featured && (
                      <span className="pricing-row-label"> standard</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="pricing-vat-note">
            Velja za vse storitve zgoraj. Vse navedene cene vključujejo DDV.
          </p>
        </div>
      </section>

      <ServiceModal
        service={selectedService}
        onClose={() => setSelectedService(null)}
      />
      <Testimonials />
    </div>
  );
};

export default Services;
